// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__YnfVY","range":"MonthRangeSwitch_range__2rPqB","disabled":"MonthRangeSwitch_disabled__1e2m5"};